import { useEffect, useRef, useState } from 'react'
import { getTableDocumentIds } from '../fetch/get-table-document-ids'

/** Refresh whole-table membership before allowing any document selection. */
export function useTableDocumentPicker(tableId: string) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [documentIds, setDocumentIds] = useState(new Set<string>())
  const request = useRef<AbortController | null>(null)
  useEffect(() => {
    setOpen(false)
    setLoading(false)
    setError(null)
    return () => request.current?.abort()
  }, [tableId])
  const show = async () => {
    request.current?.abort()
    const controller = new AbortController()
    request.current = controller
    setLoading(true)
    setError(null)
    try {
      const ids = await getTableDocumentIds(tableId, controller.signal)
      if (!controller.signal.aborted) {
        setDocumentIds(new Set(ids))
        setOpen(true)
      }
    } catch (reason) {
      if (!controller.signal.aborted) setError(reason instanceof Error ? reason.message : 'Unable to load existing table documents.')
    } finally {
      if (!controller.signal.aborted) setLoading(false)
    }
  }
  return { open, loading, error, documentIds, show, close: () => setOpen(false) }
}
